import * as React from "react";
import { useInput } from "react-admin";
import {
  Checkbox,
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";

// A react-admin multi-select rendered with CHECKBOXES in the dropdown (and the
// selected option labels, comma-joined, in the closed field) so it is obviously
// multi-select. Drop-in replacement for SelectArrayInput for our state pickers
// (matches the contract flow's MultiSelectInput look). The value is an array of
// option ids.
const StateCheckboxArrayInput = (props) => {
  const {
    label,
    choices = [],
    optionText = "name",
    optionValue = "id",
    disabled = false,
    fullWidth = true,
    helperText,
  } = props;
  const { id, field, fieldState } = useInput(props);
  const selected = Array.isArray(field.value) ? field.value : [];
  const labelId = `${id}-label`;
  return (
    <FormControl
      fullWidth={fullWidth}
      variant="filled"
      margin="dense"
      error={!!fieldState.error}
    >
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        id={id}
        label={label}
        multiple
        disabled={disabled}
        name={field.name}
        inputRef={field.ref}
        value={selected}
        onChange={field.onChange}
        onBlur={field.onBlur}
        renderValue={(vals) =>
          choices
            .filter((c) => vals.includes(c[optionValue]))
            .map((c) => c[optionText])
            .join(", ")
        }
      >
        {choices.map((c) => (
          <MenuItem key={c[optionValue]} value={c[optionValue]}>
            <Checkbox checked={selected.indexOf(c[optionValue]) > -1} />
            <ListItemText primary={c[optionText]} />
          </MenuItem>
        ))}
      </Select>
      {(helperText || fieldState.error) && (
        <FormHelperText>
          {fieldState.error?.message || helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default StateCheckboxArrayInput;
